
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSQuotationItemsSelectGrid extends _Ext.GridBase<POSQuotationItemsRow, any> {
        protected getColumnsKey() { return 'Retail.QuotationItems'; }
        protected getDialogType() { return POSQuotationItemsDialog; }
        protected getIdProperty() { return POSQuotationItemsRow.idProperty; }
        protected getInsertPermission() { return POSQuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSQuotationItemsRow.localTextPrefix; }
        protected getService() { return POSQuotationItemsForInvoiceService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
      
        constructor(container: JQuery, options) {
            super(container, options);
            var x = (this.view.params as TransactionRequest);
            x.PartyId = options.GridFilters.PartyId;
            x.InStock = options.GridFilters.InStock;
            (this.view.params as TransactionRequest) = x ; 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): POSOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }




        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
} 